import { combineReducers } from 'redux';
import { limitOrderReducer } from 'state/secondaryMarket/limit-order/limitOrder.reducer';
import { realtimeReducer } from 'state/secondaryMarket/realtime/realtime.reducer';

import { cpOrderReducer } from './cpOrder/cpOrder.reducer';
import { dlpOrderReducer } from './dlpOrder/dlpOrder.reducer';
import { liveReducer } from './live/live.reducer';
import { secondaryMarketQuotesReducer } from './productSearch/productSearch.reducer';
import { realtimeQuoteReducer } from './realtimeQuote/realtimeQuote.reducer';
import { sharedReferentialReducer } from './referential/referential.reducer';
import type { SecondaryMarketState } from './secondaryMarket.model';

export const secondaryMarketReducer = combineReducers<SecondaryMarketState>({
  productSearch: secondaryMarketQuotesReducer,
  realtimeQuote: realtimeQuoteReducer,
  cpOrder: cpOrderReducer,
  live: liveReducer,
  referential: sharedReferentialReducer,
  limitOrder: limitOrderReducer,
  realtime: realtimeReducer,
  dlpOrder: dlpOrderReducer,
});
